import React, { useEffect } from "react";
import Footer from "../components/footer";
import TeacherHeader from "../components/teacherHeader";
import SideBar from "../components/sidebar/sidebar";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  STUDENT_HOME_URL,
  TEACHER_JOURNEY_URL,
  TEACHER_ROLE,
  teacherRouteConfig,
} from "../constants";

const TeacherLayout = ({ children }) => {
  const currentUser = useSelector((state) => state?.auth?.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser === null) {
      navigate("/");
    } else if (currentUser?.role && currentUser?.role !== TEACHER_ROLE) {
      navigate(STUDENT_HOME_URL);
    }

    // below line is for hide warning of passing handlers in dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  return (
    <div>
      <TeacherHeader />
      <div className="d-flex">
        {currentUser?.role === TEACHER_ROLE ? (
          <SideBar routeConfig={teacherRouteConfig} />
        ) : (
          ""
        )}

        <div
          className="container-fluid p-0"
          // style={{backgroundColor: "#eeeeee"}}
        >
          <main>
            <div className="main_standard" style={{ minHeight: "90vh" }}>
              {children}
            </div>
          </main>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default TeacherLayout;
